module.exports = __webpack_public_path__ + "static/media/testing-pack-offer-bg.cc25e0e0.jpg";